import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const COURSE_CATEGORY = [{ code: 'ニキビ', value: '0' }, { code: 'フェイシャル（しわ・たるみ）', value: '1' }, { code: 'ダイエット', value: '2' }, { code: 'ボディスキン（背中・二の腕）', value: '3' }, { code: 'ブライダルエステ', value: '4' }];

export const STATUS_RESERVATION = [{ code: '仮予約', value: 'TEMPORARY_RESERVATION' }, { code: '予約確定', value: 'RESERVATION_CONFIRMED' }, { code: '確認済み', value: 'PRE_CONFIRMATION' }, { code: 'キャンセル', value: 'CANCEL_RESERVATION' }, { code: '当日キャンセル', value: 'CANCEL_TODAY_RESERVATION' }];/* { code: '前確OK', value: 'PRE_CONFIRMATION' }*/

export const STATUS_RESERVATION_CREATE = [{ code: '仮予約', value: 'TEMPORARY_RESERVATION' }, { code: '予約確定', value: 'RESERVATION_CONFIRMED' }];/* { code: '前確OK', value: 'PRE_CONFIRMATION' }*/

// 予約フォーム（店舗用・既存顧客）のステータス初期値
export const DEFAULT_RESERVE_STATUS_CREATE = 'RESERVATION_CONFIRMED';

export const LIST_RESERVATION_ROUTE = [{ code: '電話', value: '1' }, { code: 'メール', value: '2' }, { code: 'その他', value: '3' }];

export const MINUTE_TIME_INTERVAL_OF_EACH_OPTION_LIST_DESIRED = 15; // after 15 minute then option time of list desired will increase 15 minute

const renderQuarterHours = () => {
  const quarterHours = ['00', '15', '30', '45'];
  const times = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 24; i++) {
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < 4; j++) {
      times.push(`${i < 10 ? `0${i}` : i}:${quarterHours[j]}`);
    }
  }
  return times;
};
export const LIST_DESIRED_TIME_RESERVATION = renderQuarterHours();


export const LIST_TREATMENT_TIME_OLD_CUSTOMER = [{ value: '30', text: '30分' }, { value: '60', text: '60分' }, { value: '90', text: '90分' }, { value: '120', text: '120分' }, { value: '150', text: '150分' }, { value: '180', text: '180分' }, { value: '210', text: '210分' }, { value: '240', text: '240分' }, { value: '270', text: '270分' }, { value: '300', text: '300分' }, { value: '330', text: '330分' }, { value: '360', text: '360分' }];
export const LIST_TREATMENT_TIME_NEW_CUSTOMER = [{ value: '60', text: '60分' }, { value: '90', text: '90分' }, { value: '120', text: '120分' }, { value: '150', text: '150分' }, { value: '180', text: '180分' }];

export const LIST_TIME_ZONE = [{ value: '1', text: '通常' }, { value: '2', text: 'デイタイム' }];

export const LIST_CLASS_TYPE = [{ value: '1', text: 'レディース' }, { value: '2', text: 'メンズ' }];

export const LIST_DATE_IN_WEEKDAY = [
  ['regularHolidayMonday', '月曜日'],
  ['regularHolidayTuesday', '火曜日'],
  ['regularHolidayWednesday', '水曜日'],
  ['regularHolidayThursday', '木曜日'],
  ['regularHolidayFriday', '金曜日'],
  ['regularHolidaySaturday', '土曜日'],
  ['regularHolidaySunday', '日曜日'],
];


// Booking Online New
export const YEAR_ARRAY = Array.from({ length: 101 }, (k, i) => (new Date().getFullYear() - 100) + i);
export const MONTH_ARRAY = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
export const getStringArrayDay = (MonthNumber:number | string, YearNumber:number | string) => {
  let daysToShowArray = [];
  const endDay:number = +moment(`${YearNumber}-${MonthNumber}`).endOf('month').format('DD');
  daysToShowArray = Array.from({ length: endDay || 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  return daysToShowArray;
};
export const getTextGender = (key:string|number) => {
  switch (String(key)) {
    case '1':
      return 'FEMALE';
    case '2':
      return 'MALE';
    default:
      return '';
  }
};
